import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import * as actionType from '../../store/state/actions';
import { logAndCatchError } from '../../utils/rxjs-utils';
import { resolveRestApi } from '../../router/app-router';
import { fetch } from '../../service_broker/fetch';

const DXAPI_ERROR = 'Error occurred during ajax call at deleteDataObject Epic';

const executeDeleteDataObjectRequest = (actionInPayload: any) => {
  const { dataViewName, context, dataViewParameters } = actionInPayload;
  const requestPayloadAPI = {
    data_view_ID: dataViewName,
    dataViewParameters: encodeURIComponent(JSON.stringify(dataViewParameters))
  };
  const { restApi, reqType } = resolveRestApi(actionType.ACTION_DELETE_DATA_OBJECT, requestPayloadAPI);
  return from(
    fetch(
      restApi,
      {
        method: reqType
      },
      context
    )
  ).pipe(
    map((response: any) => {
      return {
        response: response.data,
        actionInPayload
      };
    }),
    logAndCatchError(DXAPI_ERROR, context)
  );
};

export default executeDeleteDataObjectRequest;
